module.exports = __webpack_public_path__ + "front/img/yqh03.c40e9888.png";